import React from 'react'
import { TABLA_HISTOGRAMA_BALANZAS } from '../../../../config/tables'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'

function HistogramaBalanzasView () {
  return (
    <div style={{ margin: '8px 0' }}>
      <MuiTable id={TABLA_HISTOGRAMA_BALANZAS} />
    </div>
  )
}

export default HistogramaBalanzasView
